import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import PropTypes from 'prop-types'

const SearchBar = ({ onChange, onSubmit, initialQuery }) => {
  const queryDidChange = e => {
    let query = e.target.value
    queryWouldSubmitThrottled.cancel()
    queryWouldSubmitThrottled()
    onChange(query)
  }

  const queryWouldSubmit = () => onSubmit()

  const queryWouldSubmitThrottled = _.throttle(queryWouldSubmit, 500, { leading: false, trailing: true })

  return (
    <div className="search-bar">
      <input
        id="search-input"
        className="search-bar-input form-control"
        type="search" placeholder="Search" defaultValue={initialQuery}
        onChange={queryDidChange}
        onKeyPress={e => e.key == 'Enter' && queryWouldSubmit()}
        style={{ border: '2px solid #555', backgroundColor: '#fff', color: '#000' }}
      />
      <i className="search-bar-search-icon" onClick={queryWouldSubmit}>
        <FontAwesomeIcon icon={faSearch} />
      </i>
    </div>
  )
}

SearchBar.propTypes = {
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  initialQuery: PropTypes.string,
}

export default SearchBar
